import { BestOffer } from '@bowtie-web/common';

// Signed in and in the rollout. Both compared to `true`, so an unresolved
// Statsig gate reads as off rather than as a truthy object.
export const getShouldUseBestOffer = (
  isAuthenticated?: boolean,
  isRolloutEnabled?: boolean,
): boolean => isRolloutEnabled === true && isAuthenticated === true;

// Read once, when CouponForm mounts; the field owns the value after that.
export const getInitialCouponCode = (
  shouldUseBestOffer: boolean,
  bestOffer: BestOffer | undefined,
  defaultCouponCode: string,
): string =>
  (shouldUseBestOffer && bestOffer?.code
    ? bestOffer.code
    : defaultCouponCode
  ).toUpperCase() || '';
